module.exports = __webpack_public_path__ + "static/media/lightningGamesPlayed_500000_1000000.9e35dad6.png";